/* Birthstone pickers for products with a "Number of Birthstones" option.
   Loads after selma-picker-config.js and before selma-picker.js. */
(function () {
  var C = window.SELMA_PICKER_CONFIG;
  if (!C) return;
  var b = 'https://cdn.shopify.com/s/files/1/0549/7084/3221/files/oval-birthstone-';
  C.sets.set6 = ['jan', 'february', 'march-aquamarine', 'april-diamond', 'may-emerald', 'june-alexandrite', 'july-ruby', 'august-peridot', 'september-sapphire', 'october-pink-tourmaline', 'november-citrine', 'december-blue-topaz'].map(function (s) { return b + s + '.webp'; });
  function stones(n, set) {
    var f = [];
    for (var i = 1; i <= n; i++) f.push({ k: 'stones', name: 'properties[birthstone_' + i + ']', label: '#' + i + ' Birthstone:', n: 12, set: set });
    return f;
  }
  var add = { 'marquise-kin-birthstone-ring': stones(3, 'set6'), 'princess-cut-birthstone-ring': stones(5, 'set2'), 'fine-baguette-birthstone-bracelet': stones(5, 'set0') };
  Object.keys(add).forEach(function (h) {
    var p = C.products[h] || (C.products[h] = { o: {}, f: [] });
    p.f = add[h];
  });
})();
